var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 21.25V16.375H27.6V13.125L34 18.8125L27.6 24.5V21.25H22.8ZM21.2 11.0125V13.125H2V11.0125L11.6 5L21.2 11.0125ZM10 14.75H13.2V22.875H10V14.75ZM3.6 14.75H6.8V22.875H3.6V14.75ZM19.6 14.75V18.8125L16.4 21.7375V14.75H19.6ZM13.36 24.5L12.4 25.3125L15.12 27.75H2V24.5H13.36ZM26 22.875V27.75H21.2V31L14.8 25.3125L21.2 19.625V22.875H26Z",
    fill: "#65C953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankWire);
export default __webpack_public_path__ + "static/media/bank-wire.8901c36a98950519dfa7ab6dce4c5cd3.svg";
export { ForwardRef as ReactComponent };